import { render, staticRenderFns } from "./CreatorDetailCollect.vue?vue&type=template&id=971efed6&scoped=true"
import script from "./CreatorDetailCollect.vue?vue&type=script&lang=js"
export * from "./CreatorDetailCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971efed6",
  null
  
)

export default component.exports